<template>
  <div>
    <div class="formBackground" id="data-capture-formId">
      <b-row>
        <h2>
          <b>Data Capture Forms</b>
        </h2>
      </b-row>
      <b-row class="pb-20">
        <h6>
          <b>Create, manage, and schedule data capture forms for this study.</b>
        </h6>
      </b-row>
      <b-row>
        <b-col cols="12" class="pl-0 pr-40">
          <b-row class="pb-20">
            <b-col cols="3" class="p-0">
              <input type="text" class="form-control mb-10 br-25 search-field" placeholder="Search" v-model="searchTerm" @keyup.enter="searchFormName(searchTerm)" />
            </b-col>
            <b-col cols="9" class="text-right p-0">
              <b-btn class="fs-12 mr-10 btnBgColor" size="lg" @click="showFormsForSelection()">Create a Packet</b-btn>
              <b-btn class="fs-12 mr-10 btnBgColor" size="lg" @click="selectActivityFromLibrary()">Select From Library</b-btn>
              <b-btn variant="primary" class="btn fs-12 create-activity btn-primary" size="lg" v-on:click="createActivity()"><img class="create-activity-img" src="static/img/activity-configurator/Create-Activity.svg" /><span class="create-activity-text">Create New</span></b-btn>
            </b-col>
          </b-row>
          <div class="row">
            <div :class="previewSelectedId ? 'col-md-6 pl-0' : 'col-md-12 p-0'">
              <div class="row">
                <div class="col-md-12 tableBg mb-25">
                  <b-row>
                    <b-col cols="10" class="p-0">
                      <h6>
                        <b>
                          <span class="noOfForms">{{ forms.length }}</span>
                          Forms
                        </b>
                      </h6>
                    </b-col>
                    <b-col cols="2" class="p-0 text-right">
                      <b-form-select v-model="selectedShowOption" :options="scheduleFormOptions" class="mb-3 fs-12" size="sm" @change="showForms" />
                    </b-col>
                  </b-row>
                  <template v-if="forms && forms.length">
                    <table class="tableBg2 create-edit-packet-page__order-table" style="width: 100%">
                      <colgroup>
                        <col style="width: 3%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 25%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 16%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 12%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 7%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 25%" />
                      </colgroup>
                      <colgroup>
                        <col style="width: 3%" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th class="p-0"></th>
                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('name')">
                            Name
                            <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>

                          <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('type')">
                            Type
                            <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                              <i class="fa fa-angle-up" aria-hidden="true"></i>
                            </span>
                            <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                              <i class="fa fa-angle-down" aria-hidden="true"></i>
                            </span>
                          </th>
                          <template v-if="!previewSelectedId">
                            <th class="p-0">Scheduled</th>
                            <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('createdBy')">
                              Created By
                              <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </span>
                              <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </th>
                            <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('groupName')">
                              Group
                              <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </span>
                              <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </th>
                            <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('stepsCount')">
                              Steps
                              <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </span>
                              <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </th>
                            <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('timeToComplete')">
                              Duration
                              <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </span>
                              <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </th>
                            <th class="p-0">Languages</th>
                            <th class="p-0 cursor-pointer" @click="toggleSortForUnselectedFormData('modifiedTime')">
                              Last Modified
                              <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                                <i class="fa fa-angle-up" aria-hidden="true"></i>
                              </span>
                              <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                                <i class="fa fa-angle-down" aria-hidden="true"></i>
                              </span>
                            </th>
                            <th class="p-0"></th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(form, index) in currentFormList" :key="index" class="mb-10" :class="form.id === previewSelectedId ? 'preview-background-grey' : ''">
                          <td>
                            <img @click="closePreview" v-if="previewSelectedId" src="static/img/surveyPreview/show.png" class="cursor-pointer" alt />
                            <img @click="openPreview(form)" v-else src="static/img/surveyPreview/hide.png" class="cursor-pointer" alt />
                          </td>
                          <td class="form-name p-0">
                            <label>
                              <span class="form-name">
                                <router-link
                                  class="color_4c8ce4"
                                  v-if="form.type == 'EDC'"
                                  :to="{
                                    name: 'form-view',
                                    params: { formId: form.id }
                                  }"
                                  >{{ nullvaluechecker(form.name) }}</router-link
                                >
                                <router-link
                                  class="color_4c8ce4"
                                  v-if="form.type != 'EDC'"
                                  :to="{
                                    name: 'activity-form-view',
                                    params: {
                                      formId: form.id,
                                      isNotificationIcon: true
                                    }
                                  }"
                                  >{{ nullvaluechecker(form.name) }}</router-link
                                >
                              </span>
                            </label>
                          </td>
                          <td class="form-text activity_type mt-7 p-0">
                            <span>{{ form.type }}</span>
                          </td>
                          <template v-if="!previewSelectedId">
                            <td>
                              <div class="p-0 schedulemilestone" v-if="form.frequency && form.frequency != undefined">
                                <span>
                                  {{ form.frequency.title }}
                                </span>
                              </div>
                              <div class="p-0 schedulemilestone" v-else-if="form.milestonesList && form.milestonesList.length > 0">
                                <span v-for="(milestone, index) in getSortedMilestoneList(form, 0, 3)" :key="index" :id="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                  {{ milestone.milestoneName }}
                                  <span v-if="index + 1 < form.milestonesList.length">,</span>

                                  <b-tooltip :target="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                    <div v-for="(listOfMilestones, index) in studyData.milestonesList" :key="index">
                                      <span v-if="milestone.milestoneId === listOfMilestones.milestoneId">Milestone {{ index + 1 }}</span>
                                    </div>
                                    <div>
                                      <span>Day {{ milestone.milestoneDay }}</span>
                                    </div>
                                  </b-tooltip>
                                </span>
                                <button v-if="form.milestonesList && form.milestonesList.length > 3" variant="primary" class="btn plus_btn" size="lg" :id="`selected-${form.id}-milestone`" tabindex="0">
                                  +
                                </button>
                                <b-popover :target="`selected-${form.id}-milestone`" triggers="click blur" placement="right" container="data-capture-formId">
                                  <div class="create-edit-packet-table__language-pop-over-container">
                                    <ul class="create-edit-packet-table__languages-list">
                                      <li class="create-edit-packet-table__languages-list-item" v-for="(milestone, index) in getSortedMilestoneList(form, 3, form.length)" :key="index" :id="'form_' + form.id + 'milestone_' + milestone.milestoneId">
                                        {{ milestone.milestoneName }}
                                      </li>
                                    </ul>
                                  </div>
                                </b-popover>
                              </div>
                              <div v-else-if="form.activitySchedulingMode === 'onDemand'">
                                <span>
                                  On-demand Only
                                </span>
                              </div>
                              <button v-else variant="primary" class="schedule-btn-box" size="lg" @click="scheduleActivity(form)">
                                <span class="schedule-btn-txt">Schedule</span>
                              </button>
                            </td>
                            <td class="p-0">
                              {{ nullvaluechecker(form.createdBy) }}
                            </td>
                            <td class="p-0">
                              {{ nullvaluechecker(form.groupName) }}
                            </td>
                            <td class="p-0">
                              {{ nullvaluechecker(form.stepsCount) }}
                            </td>
                            <td class="p-0">
                              {{ nullvaluechecker(form.timeToComplete) ? nullvaluechecker(form.timeToComplete) : "" }}
                            </td>
                            <td class="p-0">
                              <span class="create-edit-packet-table__language-box" :id="`selected-${form.id}-language`" tabindex="0">
                                {{ (form.language && form.language.length) || 0 }}
                              </span>
                              <b-popover :target="`selected-${form.id}-language`" triggers="click blur" placement="left" container="data-capture-formId">
                                <div class="create-edit-packet-table__language-pop-over-container" v-if="form.language && form.language.length">
                                  <ul class="create-edit-packet-table__languages-list">
                                    <li class="create-edit-packet-table__languages-list-item" v-for="(language, index) in getSortedLanguage(form.language)" :key="index">
                                      {{ nullvaluechecker(language.display_name) }}
                                    </li>
                                  </ul>
                                </div>
                              </b-popover>
                            </td>
                            <td class="p-0 date-text">
                              {{ nullvaluechecker(getLastModifiedTime(form)) }}
                            </td>
                            <td class="p-0 text-right">
                              <div class="dropleft">
                                <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="action-icon dropdown-toggle" />
                                <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span v-if="form.type == 'EDC'" class="dropdown-item pl-0 disabled">Create Copy</span>
                                    <span v-else @click.stop="createActivityCopy(form, 'data-capture-form-activity-details')" class="dropdown-item pl-0">Create Copy</span>
                                  </li>
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="downloadObjectAsJson(form.activityId, form.revisionId)" class="dropdown-item pl-0">Export JSON</span>
                                  </li>
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="exportActivityPdf(form, 'data-capture-form-activity-export')" class="dropdown-item pl-0">Export PDF</span>
                                  </li>
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="exportActivityPdf(form, 'data-capture-form-activity-export')" class="dropdown-item pl-0">Print Activity</span>
                                  </li>
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="reviseActivity(form, 'study-activities-activity-details')" class="dropdown-item pl-0">Revise</span>
                                  </li>
                                  <li class="border-bottom settings-dropdown-item fs-12">
                                    <span @click="scheduleActivity(form)" class="dropdown-item pl-0">Schedule Form</span>
                                  </li>

                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="setNotification(form)" class="dropdown-item pl-0">
                                      Notifications
                                    </span>
                                  </li>
                                  <li href="#" class="border-bottom settings-dropdown-item fs-12">
                                    <span @click.stop="removeForm(form)" class="dropdown-item pl-0">Remove</span>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </template>
                        </tr>
                      </tbody>
                    </table>
                  </template>
                  <div v-else class="text-center fs-16 mb-15 p-20">
                    No forms found for this study.
                  </div>
                  <b-row class="pt-20" v-if="forms && forms.length">
                    <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                      <i class="fa fa-angle-left fs-23"></i>
                    </div>
                    <div class="pagination">{{ currentPage }}</div>
                    <div class="pagination2">of {{ totalPages }}</div>
                    <div @click="nextPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage >= totalPages }">
                      <i class="fa fa-angle-right fs-23"></i>
                    </div>
                  </b-row>
                </div>
              </div>
            </div>
            <div class="col-md-6 tableBg mb-25" v-if="previewSelectedId">
              <div class="row mb-15">
                <div class="col-lg-2 device-view-btn p-0" v-if="showDeviceButton == true && showStepView == true" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/surveyPreview/phone.png" />Device view</div>
                <div class="col-lg-2 p-0" v-if="showDeviceButton == false && showStepView == true"></div>
                <div class="col-lg-2 device-view-btn" v-if="showStepView == false" @click.stop="toggleStepView()"><img class="mr-5" src="static/img/activity-configurator/device-step-preview.svg" />Step view</div>
                <div class="col-lg-7 p-0 activity-data-name-preview" v-if="showStepView == true">
                  {{ activityData.name }}
                </div>
                <div class="col-lg-3 p-0" v-if="showStepView == true">
                  <div class="d-inline-block pr-15">{{ activityData.stepsCount }}&nbsp;Screens</div>
                  <div v-if="activityData.timeToComplete" class="d-inline-block">{{ activityData.timeToComplete }}&nbsp;min</div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 p-0" v-if="showStepView == true">
                  <readOnlyQuestions class :questions="questionAnswers" :activityData="activityData"></readOnlyQuestions>
                </div>
                <div v-if="showStepView == false" class="col-md-12 device-view-preview">
                  <deviceQuestionsViewLibrary class :questions="questionAnswers" :activityData="activityData"></deviceQuestionsViewLibrary>
                </div>
              </div>
            </div>
          </div>
          <div class="tableBg mb-25">
            <b-row>
              <b-col cols="10" class="p-0">
                <h6>
                  <b>
                    <span class="noOfForms">{{ unscheduledPackets.length }}</span>
                    Packets
                  </b>
                </h6>
              </b-col>
              <b-col cols="2" class="p-0 text-right">
                <b-form-select v-model="packetShowOption" :options="unScheduleFormOptions" class="mb-3 fs-12" size="sm" @change="showPackets" />
              </b-col>
            </b-row>
            <table v-if="unscheduledPackets && unscheduledPackets.length" class="tableBg2 create-edit-packet-page__order-table" style="width: 100%">
              <thead>
                <tr>
                  <th class="p-0" width="3%"></th>
                  <th class="p-0" width="25%">
                    Name
                    <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                      <i class="fa fa-angle-up" aria-hidden="true"></i>
                    </span>
                    <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </th>
                  <th class="p-0" width="21%">Scheduled</th>
                  <th class="p-0" width="20%">
                    Number of Forms
                    <span class="sortUp" @click="sortUnselectedFormData('stepsCount', 'ASC')">
                      <i class="fa fa-angle-up" aria-hidden="true"></i>
                    </span>
                    <span class="sortDown" @click="sortUnselectedFormData('stepsCount', 'DESC')">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </th>
                  <th width="10%">
                    Last Modified
                    <span class="sortUp" @click="sortUnselectedFormData('createdBy', 'ASC')">
                      <i class="fa fa-angle-up" aria-hidden="true"></i>
                    </span>
                    <span class="sortDown" @click="sortUnselectedFormData('createdBy', 'DESC')">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </th>
                  <th class="p-0" width="3%"></th>
                </tr>
              </thead>
              <tr v-for="(packet, index) in currentPacketList" :key="index" class="pb-10">
                <td class="p-0"></td>
                <td class="form-name p-0">
                  <label>
                    <span class="form-name">
                      <router-link
                        :to="{
                          name: 'create-edit-packet',
                          params: {
                            studyId: studyId,
                            packetId: packet.id,
                            packet: packet
                          }
                        }"
                        >{{ packet.name }}
                      </router-link>
                    </span>
                  </label>
                </td>

                <td class="p-0">
                  <div class="p-0 schedulemilestone" v-if="packet.frequency && packet.frequency != undefined">
                    <span>
                      {{ packet.frequency.title }}
                    </span>
                  </div>
                  <div class="p-0" v-else-if="packet.milestonesList && packet.milestonesList.length > 0">
                    <span v-for="(milestone, index) in getSortedMilestoneListPacket(packet)" :key="index" :id="'packet_' + packet.id + 'milestone_' + milestone.milestoneId">
                      {{ milestone.milestoneName }}
                      <span v-if="index + 1 < packet.milestonesList.length">,</span>

                      <b-tooltip :target="'packet_' + packet.id + 'milestone_' + milestone.milestoneId">
                        <div>
                          <div v-for="(listOfMilestones, index) in studyData.milestonesList" :key="index">
                            <span v-if="milestone.milestoneId === listOfMilestones.milestoneId">Milestone {{ index + 1 }}</span>
                          </div>
                        </div>
                        <div>
                          <span>Day {{ milestone.milestoneDay }}</span>
                        </div>
                      </b-tooltip>
                    </span>
                  </div>
                  <div v-else-if="packet.activitySchedulingMode === 'onDemand'">
                    <span>
                      On-demand Only
                    </span>
                  </div>
                  <button v-else variant="primary" class="schedule-btn-box" size="lg" @click="schedulePacket(packet)">
                    <span class="schedule-btn-txt">Schedule</span>
                  </button>
                </td>
                <td class="p-0">
                  <b-col cols="6" class="form-text p-0 create-edit-packet-table__language-box" :id="`selected-${packet.id}-unscheduledForms`" tabindex="0" v-if="packet.unscheduledForms && packet.unscheduledForms.length > 0">{{ packet.unscheduledForms.length }}</b-col>
                  <b-popover :target="`selected-${packet.id}-unscheduledForms`" triggers="click blur" placement="left" container="data-capture-formId">
                    <div class="create-edit-packet-table__language-pop-over-container" v-if="packet.unscheduledForms && packet.unscheduledForms.length">
                      <ul class="create-edit-packet-table__languages-list">
                        <li class="create-edit-packet-table__languages-list-item" v-for="(unscheduledForm, index) in packet.unscheduledForms" :key="index">
                          {{ unscheduledForm.formName }}
                        </li>
                      </ul>
                    </div>
                  </b-popover>
                </td>
                <td class="p-0">{{ getLastModifiedTimeForPacket(packet) }}</td>
                <td class="p-0">
                  <b-col cols="1" class="p-0 float-right">
                    <div class="dropleft">
                      <img src="static/img/activity-configurator/row-settings.svg" id data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" alt class="action-icon dropdown-toggle" />
                      <ul class="dropdown-menu action-dropdown-menu p-0 dropleft">
                        <li class="border-bottom settings-dropdown-item fs-12">
                          <span @click.stop="copyPacket(packet)" class="dropdown-item pl-0">Create Copy</span>
                        </li>
                        <li class="border-bottom settings-dropdown-item fs-12">
                          <span @click.stop="editPacket(packet)" class="dropdown-item pl-0">Edit</span>
                        </li>
                        <li class="border-bottom settings-dropdown-item fs-12">
                          <span @click.stop="schedulePacket(packet)" class="dropdown-item pl-0">Schedule Packet</span>
                        </li>
                        <li href="#" class="border-bottom settings-dropdown-item fs-12">
                          <span @click.stop="removePacket(packet)" class="dropdown-item pl-0">Remove</span>
                        </li>
                      </ul>
                    </div>
                  </b-col>
                </td>
              </tr>
            </table>

            <div v-else class="text-center fs-16 mb-15 p-20">
              No packets found for this study.
            </div>
            <b-row class="pt-20" v-if="unscheduledPackets && unscheduledPackets.length">
              <div @click="prevPacketPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPacketPage <= 1 }">
                <i class="fa fa-angle-left fs-23"></i>
              </div>
              <div class="pagination">{{ currentPacketPage }}</div>
              <div class="pagination2">of {{ totalPacketPages }}</div>
              <div
                @click="nextPacketPage"
                class="arrow-icon cursor_pointer"
                :class="{
                  disabledPagination: currentPacketPage >= totalPacketPages
                }"
              >
                <i class="fa fa-angle-right fs-23"></i>
              </div>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import slice from "lodash/slice";
import ceil from "lodash/ceil";
import filter from "lodash/filter";
import orderBy from "lodash/orderBy";
import _ from "lodash";
import readOnlyQuestions from "@/components/activity-library/activity-preview-read-only-questions";
import deviceQuestionsViewLibrary from "@/components/activity-library/activity-device-view-library";
import moment from "moment";
import sortBy from "lodash/sortBy";
import toastr from "toastr";

export default {
  name: "forms-list",
  components: { deviceQuestionsViewLibrary, readOnlyQuestions },
  data() {
    return {
      isNotifications: false,
      activityTypes: [],
      questionAnswers: [],
      activityData: { title: "", nickName: "", questions: [] },
      showStepView: true,
      previewSelectedId: null,
      forms: [],
      showDeviceButton: true,
      selectedForms: [],
      studyId: this.$route.params.studyId,
      selectedShowOption: 10,
      currentPage: 1,
      totalPages: 1,
      searchTerm: "",
      currentFormList: [],
      allForms: [],
      edcActivityTypeIds: [],
      unscheduledPackets: [],
      allUnscheduledPackets: [],
      selectedPackets: [],
      currentPacketPage: 1,
      totalPacketPages: 1,
      packetShowOption: 10,
      currentPacketList: [],
      scheduleFormOptions: [],
      unScheduleFormOptions: [],
      notSelectedFormInPacket: [],
      formLists: [],
      sortMap: {
        name: "ASC",
        type: null,
        createdBy: null,
        groupName: null,
        stepsCount: null,
        timeToComplete: null,
        modifiedTime: null
      },
      notificationTypes: {
        noAnswer: "If no answer is provided",
        anyAnswer: "If any answer is provided",
        specificAnswer: "If a specific answer is provided",
        minMaxAnswer: "If value is above/below set threshold"
      }
    };
  },
  props: {
    studyData: {
      type: Object
    }
  },
  computed: {},
  async created() {
    this.getActivityTypes();
  },
  methods: {
    getSortedLanguage(languages) {
      return sortBy(languages, [
        function(o) {
          return o.display_name.toLowerCase().trim();
        }
      ]);
    },
    nullvaluechecker(emit) {
      return emit == null ? 0 : emit;
    },
    toggleStepView() {
      const activitytype = this.getActivityType(this.activityData.typeId);
      this.showStepView = !this.showStepView;
      this.showDeviceButton = true;
      if (activitytype && activitytype.is_participant_facing == 1) {
        this.showStepView = true;
        this.showDeviceButton = false;
      }
    },
    getActivityType(typeId) {
      if (this.activityTypes[typeId]) {
        return this.activityTypes[typeId];
      }
      return null;
    },
    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          const activityTypes = response.data.result;
          _.forEach(activityTypes, activityType => {
            this.activityTypes[activityType.id] = activityType;
            if (activityType.is_participant_facing == 1) {
              this.edcActivityTypeIds.push(activityType.id);
            }
          });
        })
        .catch(() => {
          this.$toastr.error("Error in getting Activity types");
        });
    },
    editPacket(packet) {
      this.$router.push({
        name: "create-edit-packet",
        params: { studyId: this.studyId, packetId: packet.id }
      });
    },
    schedulePacket(packet) {
      this.$router.push({
        name: "schedule-packet",
        params: { studyId: this.studyId, packetId: packet.id }
      });
    },
    downloadObjectAsJson(activityId, revisionId) {
      toastr.success("Activity file export in progress. Download will begin momentarily.");
      this.$api.getActivityDetails(activityId, revisionId).then(response => {
        const activityData = response.data.result;
        const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(activityData));
        const downloadAnchorNode = document.createElement("a");
        downloadAnchorNode.setAttribute("href", dataStr);
        downloadAnchorNode.setAttribute("download", activityData.name + ".json");
        // required for firefox
        document.body.appendChild(downloadAnchorNode);
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
    },

    getActivityDetails(activityId, revisionId) {
      this.$api.getActivityDetails(activityId, revisionId).then(
        response => {
          this.activityData = response.data.result;
          const activitytype = this.getActivityType(this.activityData.typeId);
          this.showDeviceButton = true;
          if (activitytype && activitytype.is_participant_facing == 1) {
            this.showStepView = true;
            this.showDeviceButton = false;
          }
          this.$store.dispatch("setActivityDetailsAction", response.data.result);
          if (this.activityData.questions && this.activityData.questions.length > 0) {
            this.questionAnswers = this.processQuestion(response.data.result.questions);
            this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
          }
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    processQuestion(question) {
      question.map(value => {
        if (value.type == "SurveyInstruction") {
          if (value.formattedTitle == "") {
            value.formattedTitle = value.title;
          }
          if (value.formattedInformation == "") {
            value.formattedInformation = value.information;
          }
        } else if (value.type == "CustomScale" && value.formattedLabels == undefined) {
          value.formattedLabels = value.labels;
        } else {
          if (value.formattedBody == "") {
            value.formattedBody = value.body;
          }
          if (value.options !== undefined && value.options.formattedBody == "") {
            value.options.formattedBody = value.options.body;
          }
        }
      });
      return question;
    },
    openPreview(form) {
      this.previewSelectedId = form.id;
      this.questionAnswers = [];
      this.activityData = {};
      this.$store.dispatch("activityQuestionsAction", this.questionAnswers);
      this.getActivityDetails(form.activityId, form.revisionId);
    },
    closePreview() {
      this.previewSelectedId = null;
    },
    createActivity() {
      this.$router.push({
        name: "data-capture-form-activity-details",
        params: { activityId: 0, studyId: this.studyId }
      });
    },
    scheduleActivity(form) {
      this.$router.push({
        name: "schedule-form",
        params: {
          studyId: this.studyId,
          formId: form.id,
          activityId: form.activityId,
          revisionId: form.revisionId,
          isLegacy: true
        },
        query: { type: form.type }
      });
    },
    sortLanguages(languages) {
      if (languages && languages.length > 0) {
        return languages.sort((a, b) => {
          if (a.display_name < b.display_name) {
            return -1;
          }
          if (a.display_name > b.display_name) {
            return 1;
          }
          return 0;
        });
      } else {
        return languages;
      }
    },
    sortUnselectedFormData(columnName, order) {
      this.sortMap[columnName] = order;
      let columnType = "string";
      if (columnName == "stepsCount" || columnName == "timeToComplete") {
        columnType = "number";
      }
      if (columnName == "modifiedTime") {
        columnType = "date";
      }
      if (columnType == "string") {
        this.sortByString(columnName, order);
      } else if (columnType == "number") {
        this.sortByNumber(columnName, order);
      } else if (columnType == "date") {
        this.sortByDate(columnName, order);
      }
      this.showForms(this.selectedShowOption);
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.forms.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            // sort string ascending
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.forms.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    },
    sortByNumber(columnName, order) {
      if (order == "ASC") {
        this.forms.sort((a, b) => {
          return a[columnName] - b[columnName];
        });
      } else {
        this.forms.sort((a, b) => {
          return b[columnName] - a[columnName];
        });
      }
    },
    sortByDate(columnName, order) {
      if (order == "ASC") {
        this.forms.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateA - dateB;
        });
      } else {
        this.forms.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateB - dateA;
        });
      }
    },
    toggleSortForUnselectedFormData(columnName) {
      if (this.sortMap[columnName] == null || this.sortMap[columnName] == "DESC") {
        this.sortMap[columnName] = "ASC";
      } else {
        this.sortMap[columnName] = "DESC";
      }

      this.sortUnselectedFormData(columnName, this.sortMap[columnName]);
    },
    getLastModifiedTime(form) {
      if (form.modifiedTime) {
        const modifiedTimeMoment = moment(form.modifiedTime, "YYYY-MM-DD HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    getLastModifiedTimeForPacket(packet) {
      if (packet.modifiedAt) {
        const modifiedTimeMoment = moment(packet.modifiedAt, "DD-MMM-YYYY HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    getEDCFormDetails() {
      this.$api.getEDCFormsList(this.studyId).then(response => {
        this.allForms = response.body;
        this.allForms = orderBy(this.allForms, ["name"], ["asc"]);
        this.forms = this.allForms;
        this.formLists = _.cloneDeep(response.body);
        this.forms.forEach((form, index) => {
          const data = form;
          data.index = index + 1;
        });
        this.showForms(this.selectedShowOption);
      });
    },
    getUnscheduledPackets() {
      this.$api.getUnscheduledPacketNewFactV3(this.studyId).then(response => {
        this.allUnscheduledPackets = response.body;
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.showPackets(this.packetShowOption);
      });
    },
    showForms(selectedShowOption) {
      this.totalPages = ceil(this.forms.length / selectedShowOption) === 0 ? 1 : ceil(this.forms.length / selectedShowOption);
      this.selectedForms = [];
      let start = 0;
      let end = selectedShowOption;
      for (let index = 0; index < this.totalPages; index++) {
        this.selectedForms.push(slice(this.forms, start, end));
        start += selectedShowOption;
        end += selectedShowOption;
      }
      if (!this.scheduleFormOptions || !this.scheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.scheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.currentPage = 1;
      const allForms = this.selectedForms[this.currentPage - 1];
      allForms.forEach((form, i) => {
        allForms[i]["language"] = this.sortLanguages(form.language);
      });
      this.currentFormList = allForms;
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.currentFormList = this.selectedForms[this.currentPage - 1];
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentFormList = this.selectedForms[this.currentPage];
        this.currentPage += 1;
      }
    },
    configureNewForm(duplicateFormId = null) {
      const route = {
        name: "configure-new-form",
        params: {
          studyId: this.studyId,
          formId: "0"
        }
      };
      if (duplicateFormId) {
        route.query = { duplicateFormId: duplicateFormId };
      }
      this.$router.push(route);
    },
    showFormsForSelection() {
      const route = {
        name: "show-packet",
        params: {
          studyId: this.studyId
        }
      };
      this.$router.push(route);
    },
    selectActivityFromLibrary() {
      const route = {
        name: "data-capture-form-activity-library",
        params: {
          viewMode: true,
          studyId: this.studyId
        }
      };
      this.$router.push(route);
    },
    searchFormName(searchTerm) {
      if (searchTerm) {
        let search = searchTerm;
        search = search.trim();
        this.forms = this.allForms;
        this.forms = filter(this.forms, form => form.name.toLowerCase().includes(search.toLowerCase()));
        this.showForms(this.selectedShowOption);
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.unscheduledPackets = filter(this.unscheduledPackets, packet => packet.name.toLowerCase().includes(search.toLowerCase()));
        this.showForms(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      } else {
        this.forms = this.allForms;
        this.unscheduledPackets = this.allUnscheduledPackets;
        this.showForms(this.selectedShowOption);
        this.showPackets(this.packetShowOption);
      }
    },
    showPackets(packetShowOption) {
      this.totalPacketPages = ceil(this.unscheduledPackets.length / packetShowOption) === 0 ? 1 : ceil(this.unscheduledPackets.length / packetShowOption);
      this.selectedPackets = [];
      let start = 0;
      let end = packetShowOption;
      for (let index = 0; index < this.totalPacketPages; index++) {
        this.selectedPackets.push(slice(this.unscheduledPackets, start, end));
        start += packetShowOption;
        end += packetShowOption;
      }
      if (!this.unScheduleFormOptions || !this.unScheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.unScheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.currentPacketPage = 1;
      this.currentPacketList = this.selectedPackets[this.currentPacketPage - 1];
    },
    prevPacketPage() {
      if (this.currentPacketPage <= this.totalPacketPages) {
        this.currentPacketPage -= 1;
        this.currentPacketList = this.selectedPackets[this.currentPacketPage - 1];
      }
    },
    nextPacketPage() {
      if (this.currentPacketPage < this.totalPacketPages) {
        this.currentPacketList = this.selectedPackets[this.currentPacketPage];
        this.currentPacketPage += 1;
      }
    },
    getSortedMilestoneList(form, start, end) {
      const formClone = _.cloneDeep(form);
      formClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return formClone.milestonesList.slice(start, end);
    },
    getSortedMilestoneListPacket(packet) {
      const packetClone = _.cloneDeep(packet);
      packetClone.milestonesList.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
      return packetClone.milestonesList;
    },
    removeForm(form) {
      swal({
        title: "Are you sure you want to remove this form from your study?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .removeFormV3(form.id, this.studyId)
            .then(() => {
              toastr.success("Form removed successfully");
              this.getEDCFormDetails();
            })
            .catch(error => {
              const errorMsg = error.body ? error.body.message : "Error while removing packet";
              toastr.error(errorMsg);
            });
        }
      });
    },
    setNotification(form) {
      const route = {
        name: "set-notification",
        params: { formId: form.id },
        query: { siteFacing: true }
      };
      this.$router.push(route);
    },
    createActivityCopy(form, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: form.activityId || form.id,
          revisionId: form.revisionId,
          studyId: this.studyId,
          mode: "copy"
        },
        query: { revisionId: form.revisionId, mode: "copy" }
      });
    },
    exportActivityPdf(form, path) {
      this.$router.push({
        name: path,
        params: {
          activityId: form.activityId,
          revisionId: form.revisionId,
          studyId: this.studyId
        }
      });
    },
    reviseActivity(form) {
      if (form.type == "EDC") {
        this.$router.push({
          name: "configure-new-form",
          params: {
            formId: form.id,
            studyId: this.studyId
          }
        });
      } else {
        this.$router.push({
          name: "data-capture-form-activity-details",
          params: {
            activityId: form.activityId || form.id,
            revisionId: form.revisionId,
            studyId: this.studyId,
            mode: "revise"
          },
          query: { revisionId: form.revisionId, mode: "revise" }
        });
      }
    },
    removePacket(packet) {
      swal({
        title: "Are you sure you want to remove this packet from your study?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$api
            .removePacketV3(packet.id)
            .then(() => {
              toastr.success("Packet removed successfully");
              this.getUnscheduledPackets();
            })
            .catch(error => {
              const errorMsg = error.body ? error.body.message : "Error while removing packet";
              toastr.error(errorMsg);
            });
        }
      });
    },
    copyPacket(packet) {
      const route = {
        name: "create-edit-packet",
        params: {
          studyId: this.studyId,
          packetId: packet.id,
          packet: packet,
          mode: "copy"
        }
      };
      this.$router.push(route);
    }
  },
  mounted() {
    setTimeout(() => {
      this.getEDCFormDetails();
      this.getUnscheduledPackets();
    }, 1200);
  }
};
</script>

<style scoped lang="scss">
.cursor-pointer {
  cursor: pointer;
}
.preview-background-grey {
  background-color: rgba(211, 223, 228, 0.6);
}
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
  width: 0;
  height: 0;
  background: transparent;
  border-top-width: 0;
  cursor: pointer;
}
.sortDown {
  position: relative;
  padding-left: 4px;
  width: 0;
  height: 0;
  cursor: pointer;
  top: 5px;
  z-index: 1;
}
.tableBg {
  background-color: #ffffff !important;
  padding: 24px 20px 14px 20px !important;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.form-title {
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #9b9b9b;
}

.form-name {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #1e8fe1;
}

.form-text {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
}

.text-align {
  line-height: 23px !important;
}

.arrow-icon {
  width: 25px;
  height: 25px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 30px;
  height: 25px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 25px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.search-field {
  padding-right: 30px;
  background-image: url("/static/img/icon-search.gif");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  height: 37px;
}

.noOfForms {
  color: #f16559;
}

.primaryBgColor {
  background-color: #1e8fe1;
}

.duplicate-icon img {
  vertical-align: top;
}

.duplicate-icon img:hover {
  cursor: pointer;
}

.btnBgColor {
  border-radius: 4px;
  border: solid 1px #4c8ce4;
  background-color: #ffffff;
  font-size: 12px;
  letter-spacing: normal;
  color: #4c8ce4;
}
.action-icon {
  cursor: pointer;
  height: 20px;
}
.dropleft .dropdown-toggle::before {
  border-right: 0 !important;
  transform: rotate(45deg);
  background-color: #4c8ce4;
}
.action-dropdown-menu {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px 1px;
  min-width: 7rem;
}
.settings-dropdown-item {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  cursor: pointer;
}
.create-edit-packet-table {
  &__language-box {
    width: 35px;
    height: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #4c8ce4;
    border: 1px solid #d3dee3 !important;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    line-height: 22px;

    &:focus {
      outline: none;
    }
  }

  &__language-pop-over-container {
    /* width: 210px; */
    /* height: 258px; */
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding: 0 15px 0 10px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }
}
.create-edit-packet-page {
  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-forms-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      // display: none;
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-forms-table {
    th {
      font-family: "RobotoRegular";
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 16px;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }
  }
}
</style>
<style lang="scss">
#data-capture-formId .popover {
  width: auto !important;
  margin: 0 !important;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  left: -8px !important;
  border: none;
  .popover-body {
    margin: 0 !important;
    padding: 0 !important;
  }
}
.create-edit-packet-page__order-table td a {
  position: relative;
  top: 5px;
}
.plus_btn {
  width: 26px;
  height: 24px;
  border-radius: 4px;
  border: solid 1px #d3dee3;
  background-color: #ffffff;
  color: blue;
  padding: 0;
  line-height: 20px;
}
.create-activity {
  background-color: #1e8fe1;
  height: 35px;
  line-height: 16px;
}

.create-activity-img {
  position: relative;
  right: 10px;
  bottom: 5px;
}

.create-activity-text {
  position: relative;
  bottom: 3px;
}
.schedule-btn-box {
  background-color: white;
  border-radius: 3px;
  border: solid 1px #4c8ce4;
  height: 22px;
  cursor: pointer;
}
.schedule-btn-txt {
  font-size: 12px;
  color: #4c8ce4;
}
.schedulemilestone span:nth-child(3) span {
  display: none;
}
.device-view-btn {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4c8ce4;
  cursor: pointer;
  z-index: 90;
}
.activity-data-name-preview {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  text-align: center;
}
#notificationModal .close-dialog-icon {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
h1,
h2,
h3 {
  font-weight: 200;
}
.continue-btn-modal {
  width: 150px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
}
.continue-btn-text {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
